
let loadingWindowHideOverlay = (parent) => {
  const overlay = document.querySelector(parent + ' .loading__overlay')
  if( overlay ) {
    overlay.classList.remove('visible')
  }
}

let loadingWindowVisible = (type, parent) => {
  const overlay = document.querySelector(parent + ' .loading__overlay')
  if( overlay ) {
    overlay.classList.add('visible')
  }

  const block = document.querySelector(parent + ' .loading__block--' + type)
  if( block ) {
    block.classList.add('visible')
  }
}

let loadingWindowHidden = (type, parent) => {
  const block = document.querySelector(parent + ' .loading__block--' + type)
  if( block ) {
    block.classList.remove('visible')
  }

  const errorTextBlock = document.querySelector(parent + ' .loading__error-text')
  if( errorTextBlock ) {
    errorTextBlock.innerHTML = ''
  }

  loadingWindowHideOverlay(parent)
}


let loadingWindowHandler = (parent) => {
  const buttonError = document.querySelector(parent + ' .loading__button--error')
  if( buttonError ) {
    buttonError.addEventListener('click', (event) => {
      const blocks = document.querySelectorAll(parent + ' .loading__block')
      blocks.forEach((block) => {
        block.classList.remove('visible')
      })
      loadingWindowHideOverlay(parent)
    })
  }

  const buttonSuccess = document.querySelector(parent + ' .loading__button--success')
  if( buttonSuccess ) {
    buttonSuccess.addEventListener('click', (event) => {
      const blocks = document.querySelectorAll(parent + ' .loading__block')
      blocks.forEach((block) => {
        block.classList.remove('visible')
      })

      /*const block = document.querySelector('.loading__block--success')
      if( block ) {
        block.classList.remove('visible')
      }*/

      loadingWindowHideOverlay(parent)
    })
  }
}

export {
  loadingWindowVisible,
  loadingWindowHidden,
  loadingWindowHandler
}

